module.exports = __webpack_public_path__ + "img/rare-name.b7723acd.png";